export default __webpack_public_path__ + "static/media/ConveyorLiftMK5.256.e9f815a9.png";